import { render, staticRenderFns } from "./LivrableForm.vue?vue&type=template&id=e5198fb6"
import script from "./LivrableForm.vue?vue&type=script&lang=js"
export * from "./LivrableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports